const subjectTypeOptions = [
  { value: 'PERSONALITY TRAITS', label: 'PERSONALITY TRAITS' },
  { value: 'SUBSIDIARY', label: 'SUBSIDIARY' },
  { value: 'SCHOLASTIC AREAS', label: 'SCHOLASTIC AREAS' },
  { value: 'MAIN', label: 'MAIN' },
  { value: 'DISCIPLINE', label: 'DISCIPLINE' },
  { value: 'CO-SCHOLASTIC AREAS', label: 'CO-SCHOLASTIC AREAS' }
];

const reportGroupOptions = [
  { value: 'Group II', label: 'Group II' },
  { value: 'Group III', label: 'Group III' },
  { value: 'FINAL REPORT CARD REMARKS', label: 'FINAL REPORT CARD REMARKS' }
];

const reportSubGroupOptions = [
  { value: 'SCIENCE', label: 'SCIENCE' },
  {
    value: 'HISTORY, CIVICS & GEOGRAPHY',
    label: 'HISTORY, CIVICS & GEOGRAPHY'
  },
  { value: 'ART EDUCATION', label: 'ART EDUCATION' },
  {
    value: 'HEALTH & PHYSICAL EDUCATION',
    label: 'HEALTH & PHYSICAL EDUCATION'
  },
  { value: 'II LANGUAGE', label: 'II LANGUAGE' },
  { value: 'ENGLISH', label: 'ENGLISH' }
];

export { subjectTypeOptions, reportGroupOptions, reportSubGroupOptions };
